<template>
    <div class="grid">
      <loading
        :active="isLoadingModel"
        :can-cancel="true"
        color="#173EA3"
        :is-full-page="fullPage"
      ></loading>
      <div class="col-12">
        <div class="card">
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
          <Toast />
            <div class="p-fluid formgrid grid" style="margin-top: 2%;">

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                    <InputText type="text" id="name" v-model="search_name"></InputText>
                    <label for="name">Block Name</label>
                  </span>
                </div>

                <div class="field col-12 md:col-2">
                  <span class="p-float-label">
                    <InputText type="text" id="code" maxlength="3" v-model="search_code" onkeypress="return event.charCode>=48 && event.charCode<=57"></InputText>
                    <label for="code">Block Code</label>
                  </span>
                </div>

                <div class="field col-12 md:col-2">
                  <Button
                    icon="pi pi-search"
                    v-tooltip.bottom="'Search'"
                    @click="search(1)"
                /> &nbsp;
                <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
                  </div>

                <!-- <span class="p-float-label">
                  <InputText v-model="service_name"> </InputText>
                  <label>Search...</label>
                  &nbsp;
                  <Button
                    icon="pi pi-search"
                    v-tooltip.bottom="'Search'"
                    @click="search(1)"
                /></span> -->
                <!-- <Button
                    label="New"
                    icon="pi pi-plus"
                    class="p-button-success mr-2"
                    @click="openNew"
                  /> -->
                <!-- <Button
                    label="Delete"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="confirmDeleteSelected"
                    :disabled="!selectedProducts || !selectedProducts.length"
                  /> -->
                <!-- &nbsp;
                  <Button
                    icon="pi pi-sync"
                    class="p-button-info mr-2"
                    @click="get_list"
                  /> -->
              </div>
            <!-- </template>
  
            <template v-slot:end> -->
              <!-- <FileUpload
                  mode="basic"
                  accept="image/*"
                  :maxFileSize="1000000"
                  label="Import"
                  chooseLabel="Import"
                  class="mr-2 inline-block"
                /> -->
              <!-- <Button
                icon="pi pi-plus"
                v-tooltip.bottom="'Add'"
                @click="openNew"
              />&nbsp; -->
              <!-- <json-excel :data="product">
                <Button
                 
                  icon="pi pi-upload"
                  v-tooltip.bottom="'export'"
                 @click="exportCSV"
                />
                </json-excel> -->
            <!-- </template>
          </Toolbar> -->
  
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="products"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true"
            showGridlines
          >
            <template #empty>
              <b style="text-align: center">No records found.</b>
            </template>
            <template #header>
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
              >
                <h5 class="m-0"><b> Block Master</b></h5>
                <!-- Total Records:{{totalRecords}} -->
  
                <!-- <Button
                  icon="pi pi-refresh"
                  @click="search(2)"
                  v-tooltip.bottom="'Refresh'"
                /> -->
              </div>
              <div style="text-align: right; font-weight: bold">
                <span>Total Block:</span>{{ totalRecords }}
              </div>
            </template>

            
  
            
            <Column header="Sr No" style="min-width: 5rem; text-align: center">
              <template #body="{ index }">
                <span v-if="page_no == 1">{{ +index + +1 }}</span>
                <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
              </template>
            </Column>
  
            <Column header="Code" :field="columns[1]" style="min-width: 10rem">
              <template #body="{ data }">
                {{ data.code }}
              </template>
            </Column>

            

            

            <Column header="Name" :field="columns[1]" style="min-width: 10rem">
              <template #body="{ data }">
                {{ dateFormatDMY(data.name) }}
              </template>
            </Column>


           
  
            <Column
              header="Lat."
              :field="columns[2]"
              style="min-width: 10rem"
            >
              <template #body="{ data }">
                <span v-if="data.block_lat"> {{ data.block_lat }}</span>
                <span v-else>-</span>
               
              </template>
            </Column>

            <Column
              header="Lng."
              :field="columns[2]"
              style="min-width: 10rem"
            >
              <template #body="{ data }">
                <span v-if="data.block_long"> {{ data.block_long }}</span>
                <span v-else>-</span>
   
              </template>
            </Column>

           </DataTable>
  
          <Dialog
            header="services"
            v-model:visible="productDialog"
            :breakpoints="{ '960px': '75vw' }"
            :style="{ width: '70vw' }"
            :modal="true"
          >
            
          </Dialog>
  
          <!-- 
  -----------------------------------------------------------------------------------------------------------   -->
          <Dialog
            v-model:visible="deleteProductDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete <b>{{ product.service_name }}</b
                >?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteservice"
              />
            </template>
          </Dialog>
  
          <Dialog
            v-model:visible="deleteProductsDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span v-if="product"
                >Are you sure you want to delete the selected products?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductsDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteSelectedProducts"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </template>
    
    <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import JsonExcel from "vue-json-excel";
  import BreadcrumbService from "../service/BreadcrumbService";
  
  //import FormNewsMaster from "@/components/FormNewsMaster";
  
  
  // import axios from "axios";
  import apis from "@/apis";
  import axios from "axios";
  import { log } from "util";
  
  export default {
    data() {
      return {
        place_details: "",
        end_place_details: "",
        searchme: "",
        name: "",
        page_no: 1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",
  
        icon_dropdown: [],
  
        service_name: "",

        search_name:"",
        search_code:"",
  
        dropdownItems: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          { name: "Deleted", value: "Deleted" },
        ],
  
        parent_dropdownItems: [],
        selectstatus: { name: "", value: "" },
        parent_selectstatus: { name: "", value: "" },
        pick_icon: { name: "", value: "" },
  
        products: null,
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
  
        // selectstatus2: { name: "Motivational", value: "Motivational" },
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "Course",
        ],
        pageno: 1,
        submitted: false,
        icons: null,
        totalRecords: 0,
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],

        BreadcrumbService : null,
breadcrumbHome: {},
breadcrumbItems: [],
      };
    },
    productService: null,
  
    async created() {
      this.productService = new ProductService();
      this.initFilters();

      this.BreadcrumbService = new BreadcrumbService();
	let Breadcrum_data = this.BreadcrumbService.getBreadcrum("Block Master","/block_master")
	this.breadcrumbHome=Breadcrum_data.home;
	this.breadcrumbItems=Breadcrum_data.items;
    },
    async mounted() {
     
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
  
      //alert(this.id);
    },
    watch: {
      async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
  
    methods: {
        dateFormatDMY(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return date+"/"+month+"/"+year;
                }
            }
        }
        else {
           return "";
        }
    },
    reset()
    {
      this.search_name ="";
      this.search_code = "";
      this.get_list();
      this.get_count();
    },
      async search(count) {
        count == 2 ? (this.service_name = "",
        this.search_name='',
        this.search_code=''
        ) : "";
        await this.get_list();
        await this.get_count();
      },
      async viewProduct(product) {
        // console.log(JSON.stringify(product));
        await localStorage.setItem('saveservicedata',JSON.stringify(product));
        this.$router.push({name:"serviceProfile"});
      },
      editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;
  
        this.selectstatus.value = this.product.menu_status;
        this.selectstatus.name = this.product.menu_status;
  
        this.pick_icon.value = this.product.menu_icon;
        this.pick_icon.name = this.product.menu_icon;
  
        this.parent_selectstatus = { name: "", value: "" };
        if (this.product.parentmenu.length > 0) {
          this.parent_selectstatus.value = this.product.parentmenu[0]._id;
          this.parent_selectstatus.name =
            this.product.parentmenu[0].parent_menu_name;
        }
      },
  
      isNumber(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        }
      },
  
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
  
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
        var data = {
          count: true,
          service_name: this.service_name,
          name:this.search_name,
          code:this.search_code,
          "client_group_ids":client_group_ids,
          client_id:localStorage.getItem('client_id'),
        };
        this.loading = true;
        var promise = apis.getBlockData(data);
        promise.then((response) => {
          this.loading = false;
          //   console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
  
        // console.log(data);
      },
      get_list: function () {
        const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          service_name: this.service_name,
          name:this.search_name,
          code:this.search_code,
          "client_group_ids":client_group_ids,
          client_id:localStorage.getItem('client_id'),
        };
        this.loading = true;
        var promise = apis.getBlockData(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
  
          
        });
  
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
  
        this.selectstatus = { name: "", value: "" };
        this.parent_selectstatus = { name: "", value: "" };
        this.pick_icon = { name: "", value: "" };
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      async addrole() {
        this.submitted = true;
  
        if (!this.product.service_name) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Menu Name",
            life: 3000,
          });
          return false;
        }
  
        // if (!this.product.menu_url) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Please Enter Menu URL",
        //     life: 3000,
        //   });
        //   return false;
        // }
  
        //parent menu
        // if (!this.parent_selectstatus.value) {
        //   this.$toast.add({
        //     severity: "error",
        //     summary: "error",
        //     detail: "Select Menu Parent Menu",
        //     life: 3000,
        //   });
        //   return false;
        // }
        if (!this.pick_icon.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Menu Icon",
            life: 3000,
          });
          return false;
        }
  
        if (!this.selectstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Status",
            life: 3000,
          });
          return false;
        }
        if (!this.product.menu_sequence) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Menu Sequence",
            life: 3000,
          });
          return false;
        }
  
        //edit
        if (this.product._id) {
          var data = {
            _id: this.product._id,
  
            service_name: this.product.service_name,
            menu_url: this.product.menu_url,
            menu_parent: this.parent_selectstatus.value,
            menu_icon: "pi pi-fw pi-" + this.pick_icon.value,
            menu_status: this.selectstatus.value,
            menu_sequence: this.product.menu_sequence,
            description: this.product.description,
            updated_at: "",
            updated_by: "",
          };
  
          this.isLoadingModel = true;
          var promise = apis.editmenu(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
        //add-----------------------------------------------------------------------------------------------------------------
        else {
          var data1 = {
            service_name: this.product.service_name,
            menu_url: this.product.menu_url,
            menu_parent: this.parent_selectstatus.value,
            menu_icon: "pi pi-fw pi-" + this.pick_icon.value,
            menu_status: this.selectstatus.value,
            menu_sequence: this.product.menu_sequence,
            description: this.product.description,
            created_at: "",
  
            created_by: localStorage.getItem("full_name"),
          };
          this.isLoadingModel = true;
          var promises = apis.addmenu(data1);
          promises
            .then((response) => {
              this.isLoadingModel = false;
  
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
      },
  
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
  
      deleteservice() {
        if (this.product._id) {
          var data = {
            _id: this.product._id,
            user_id: localStorage.getItem("id"),
          };
          this.isLoadingModel = true;
          var promise = apis.deleteservicedata(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
  
            if (responseapi.data.status == true) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Role");
            }
          });
        }
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
  
      async exportCSV() {
        this.limit = this.totalRecords;
        this.get_list();
        await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: { downloadExcel: JsonExcel },
  };
  </script>
    
    <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  @import "../assets/demo/documentation.scss";
  
  .icons-list {
    i {
      color: var(--text-color-secondary);
    }
  }
  </style>
    